import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { BarChart3, FileText, Calendar } from 'lucide-react';

const ScorekeeperNav: React.FC = () => {
  const location = useLocation();

  const navItems = [
    {
      path: '/scorekeeper/dashboard',
      label: 'Dashboard',
      icon: BarChart3
    },
    {
      path: '/scorekeeper/applications',
      label: 'My Applications',
      icon: FileText
    },
    {
      path: '/scorekeeper/assignments',
      label: 'Game Assignments',
      icon: Calendar
    },
    {
      path: '/scorekeeper/support-tickets',
      label: 'Support Tickets',
      icon: FileText
    }
  ];

  return (
    <div className="flex flex-wrap gap-2 mb-6">
      {navItems.map((item) => {
        const Icon = item.icon;
        const isActive = location.pathname === item.path;
        
        return (
          <Button
            key={item.path}
            asChild
            variant={isActive ? "default" : "outline"}
            size="sm"
            className={isActive ? "bg-primary text-primary-foreground" : "text-gray-300 border-gray-600 hover:bg-gray-700"}
          >
            <Link to={item.path} className="flex items-center gap-2">
              <Icon className="h-4 w-4" />
              {item.label}
            </Link>
          </Button>
        );
      })}
    </div>
  );
};

export default ScorekeeperNav;